<template>
  <div>
    <div data-eduwill-eco-content="7481" class="eco-7481"></div>
    <div class="header sub sub_on">
      <div class="float_wrapper">
        <div class="fl">
          <h1 class="logo">
            <a href="/">
              <span class="logo_wrap"></span>
              <span class="b2b">B2B</span>
            </a>
          </h1>
          <div class="gnb">
            <ul>
              <li class="s-1">
                <a href="/edu/aiEdu/main" class="menu">AI 교육</a>
              </li>
              <li class="s-2">
                <a href="/edu/onlineEdu/main" class="menu">온라인교육</a>
              </li>
              <li class="s-3">
                <a href="/edu/zoomEdu/main" class="menu">집합·화상교육</a>
              </li>
              <li class="s-4">
                <a href="/edu/cpEdu/main" class="menu">콘텐츠 공급·제휴</a>
              </li>
              <li class="s-5">
                <a href="/edu/newsRelease/main" class="menu">홍보센터</a>
              </li>
            </ul>
          </div>
        </div>
        <div class="fr">
          <a class="btn_counsel" @click="showCounsel">상담신청</a>
          <div class="btn_ham_menu" id="openNav">
            <span></span>
            <span></span>
          </div>
        </div>
      </div>
      <div class="sub_gnb_wrapper">
        <div class="sub_gnb_inner">
          <ul class="s-1">
            <li><a href="/edu/aiEdu/main">AI 국가공인 자격증(AICE)</a></li>
            <li><a href="/edu/aiEdu/Aiclass">AI CLASS</a></li>
            <li><a href="/edu/aiEdu/b2b">AI 기업교육</a></li>
          </ul>
          <ul class="s-2">
            <li><a href="/edu/onlineEdu/main">기업 위탁교육</a></li>
            <li><a href="/edu/onlineEdu/uniSell">대학 취업교육</a></li>
            <li><a href="/edu/onlineEdu/highSell">특성화고 취업교육</a></li>
          </ul>
          <ul class="s-3">
            <li><a href="/edu/zoomEdu/main">집합 교육</a></li>
            <li><a href="/edu/zoomEdu/zoomEdu">화상 교육(Zoom)</a></li>
          </ul>
          <ul class="s-4">
            <li><a href="/edu/cpEdu/main">콘텐츠·멤버십 제휴</a></li>
            <li><a href="/edu/cpEdu/cpMallEdu">제휴몰 사업</a></li>
            <li><a href="/edu/cpEdu/contentProviederEdu">교육 협약</a></li>
          </ul>
          <ul class="s-5">
            <li><a href="/edu/newsRelease/main">보도자료</a></li>
            <li><a href="/edu/newsRelease/promotionVideo">홍보영상</a></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="overlay"></div>
    <div class="offcanvas">
      <div class="off_wrapper">
        <div class="h_tabcontent">
          <ul>
            <li class="menu_link">
              <a href="javascript:;">온라인교육</a>
              <transition name="slide">
                <ul class="h_depth2" v-show="menu1">
                  <li><a href="/edu/onlineEdu/main">기업 위탁교육</a></li>
                  <li><a href="/edu/onlineEdu/uniSell">대학 취업교육</a></li>
                  <li><a href="/edu/onlineEdu/highSell">특성화고 취업교육</a></li>
                </ul>
              </transition>
            </li>
            <li class="menu_link">
              <a href="javascript:;">집합·화상교육</a>
              <transition name="slide">
                <ul class="h_depth2" v-show="menu2">
                  <li><a href="/edu/zoomEdu/main">집합 교육</a></li>
                  <li><a href="/edu/zoomEdu/zoomEdu">화상 교육(Zoom)</a></li>
                </ul>
              </transition>
            </li>
            <li class="menu_link">
              <a href="javascript:;">콘텐츠 공급·제휴</a>
              <transition name="slide">
                <ul class="h_depth2" v-show="menu3">
                  <li><a href="/edu/cpEdu/main">콘텐츠·멤버십 제휴</a></li>
                  <li><a href="/edu/cpEdu/cpMallEdu">제휴몰 사업</a></li>
                  <li><a href="/edu/cpEdu/contentProviederEdu">교육 협약</a></li>
                </ul>
              </transition>
            </li>
            <li class="menu_link">
              <a href="javascript:;">홍보센터</a>
              <transition name="slide">
                <ul class="h_depth2" v-show="menu4">
                  <li><a href="/edu/newsRelease/main">보도자료</a></li>
                  <li><a href="/edu/newsRelease/promotionVideo">홍보영상</a></li>
                </ul>
              </transition>
            </li>
          </ul>
        </div>
      </div>
      <div class="off_top">
        <div class="btn_close" id="closeNav"></div>
      </div>
    </div>
  </div>
</template>
<script>
import eventBus from "@/eventBus/event-bus";
export default {
  name: "SubHeader",

  data() {
    return {
      menu1: false,
      menu2: false,
      menu3: false,
      menu4: false,
    }
  },
  props: {
    bizCd: {
      type: String,
      default: "01"
    }
  },

  computed: {
  },

  methods: {
    showCounsel() {
      eventBus.$emit("show-counsel", this.bizCd);
    }
  },

  created() {
    this.$loadScript("https://img.eduwill.net/resources/b2b/dev/js/sub_slider.js");
  },
  beforeMount() {
  },
  mounted() {

    //$(".header").hover(function(){
    //	$(this).addClass("on");
    //}, function() {
    //$(this).removeClass("on");
    //});

    // 헤더 관련 스크립트
    /*$(".header .gnb").on("mouseenter", function(){
      $(".sub_gnb_wrapper").addClass("on");
    });
    $(".sub_gnb_wrapper").on("mouseleave", function(){
      $(".sub_gnb_wrapper").removeClass("on");
      $(".header .gnb").find("li").removeClass("hover");
    });
    $(".sub_gnb_wrapper ul").on("mouseenter", function(){
      var target = $(this).attr("class");
      $(".header .gnb").find("."+target).addClass("hover").siblings("li").removeClass("hover");
    });*/

    /*$("#openNav").on("click",function(){
      $(".offcanvas").addClass("open");
      $(".overlay").show();
      return false;
    });

    $("#closeNav").on("click",function(){
      $(".offcanvas").removeClass("open");
      $(".overlay").hide();
      return false;
    });*/

  },
}
</script>
<style scoped>
.offcanvas .off_wrapper .h_tabcontent .h_depth2 {display: block;}


.slide-enter-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: ease-in;
  -webkit-transition-timing-function: ease-in;
  -o-transition-timing-function: ease-in;
  transition-timing-function: ease-in;
}

.slide-leave-active {
  -moz-transition-duration: 0.3s;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -moz-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -webkit-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  -o-transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
  transition-timing-function: cubic-bezier(0, 1, 0.5, 1);
}

.slide-enter-to, .slide-leave {
  max-height: 100px;
  overflow: hidden;
}

.slide-enter, .slide-leave-to {
  overflow: hidden;
  max-height: 0;
}
</style>